
import { defineComponent, computed } from 'vue';
import { defineRule, Form } from 'vee-validate';
import { useProfileStore } from '../../store/profileStore';
import { IWorkplaces } from '@/types/interfaces';
import AppInput from '@/components/UI/AppInput.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import { useMainStore } from '@/store/mainStore';
import ValidationService from '@/services/ValidationService';

defineRule('zipCode', (value: string) => ValidationService.isZipCode(value) || !value || 'ZIP Code is not valid');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppSelect,
  },
  setup() {
    const profileStore = useProfileStore();
    const mainStore = useMainStore();

    const schema = {
      zipCode: 'zipCode',
    };

    function getDefaultWorkplace(): IWorkplaces {
      return {
        name: '',
        street: '',
        city: '',
        state: '',
        zipCode: null,
      };
    }

    function addWorkplace(): void {
      profileStore.bufferProfile.workplaces.push(getDefaultWorkplace());
    }

    if (!profileStore.bufferProfile.workplaces?.length) {
      addWorkplace();
    }

    const isWorkplaceFilled = computed(() => {
      const workplaces = profileStore.bufferProfile?.workplaces;
      const lastWorkplace = workplaces[workplaces.length - 1];
      return !!(lastWorkplace?.name && lastWorkplace?.city && lastWorkplace?.state && lastWorkplace?.street && lastWorkplace?.zipCode);
    });

    return {
      profileStore,
      mainStore,
      isWorkplaceFilled,
      addWorkplace,
      schema,
    };
  },
});
